<template>
  <div class="state404">
    <!-- 404 -->
    <img src="@/assets/img/404.png" alt="" />
  </div>
</template>

<script>
export default {
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.state404 {
  width: 100vw;
  height: 100vh;

  img {
    object-fit: scale-down;
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
